import { IOpoDocument } from './opo-document';

export interface IOpoAdminSettings {
    achRoutingNumber: string,
    achAccountNumberMasked: string,
    achApproved: boolean,
    achApprovedByName: string | null,
    achApprovedDateTime: string | null,
    isActive: boolean
}

export interface IOpoAdminSettingsRequest {
    achRoutingNumber: string,
    achAccountNumber: string,
    achApproved: boolean,
    isActive: boolean
}

export type IOpoAgreement = IOpoDocument;
